import { render, staticRenderFns } from "./DetailsCalendar.vue?vue&type=template&id=567514dc&"
import script from "./DetailsCalendar.vue?vue&type=script&lang=js&"
export * from "./DetailsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports